import { useState } from "react";
import { useParams } from "react-router-dom";
import { Activity, Video, ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { VideoCall } from "@/components/telemed/VideoCall";

export default function SalaTelemedicina() {
  const { roomId } = useParams();
  const [stage, setStage] = useState("lobby"); // lobby | live | ended
  const [name, setName] = useState("");

  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-br from-slate-900 via-slate-800 to-blue-950 px-4 py-6">
      <div className="mx-auto flex w-full max-w-4xl items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-blue-600"><Activity className="h-5 w-5 text-white" strokeWidth={2.5} /></div>
          <span className="font-heading text-lg font-extrabold tracking-tight text-white">VeloClin</span>
          <span className="ml-1 rounded-full border border-white/15 bg-white/5 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-300">Teleconsulta</span>
        </div>
        <span data-testid="sala-room-id" className="hidden font-mono text-xs text-slate-400 sm:block">sala: {roomId}</span>
      </div>

      <div className="mx-auto flex w-full max-w-4xl flex-1 items-center justify-center py-6" data-testid="sala-page">
        {stage === "lobby" && (
          <div className="w-full max-w-md rounded-3xl border border-white/10 bg-white p-7 shadow-2xl">
            <div className="text-center">
              <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-blue-50 text-blue-600"><Video className="h-6 w-6" /></div>
              <h1 className="font-heading text-xl font-extrabold text-slate-900">Entrar na teleconsulta</h1>
              <p className="mt-1 text-sm text-slate-500">Ao entrar, seu navegador vai pedir acesso à câmera e ao microfone.</p>
            </div>
            <div className="mt-5">
              <label className="text-xs font-semibold text-slate-600">Seu nome</label>
              <Input data-testid="sala-name-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Como o médico verá você" className="mt-1.5 border-slate-200 focus-visible:ring-blue-600" />
            </div>
            <button data-testid="sala-join-btn" onClick={() => setStage("live")} className="mt-5 flex w-full items-center justify-center gap-2 rounded-xl bg-blue-600 py-3.5 text-sm font-bold text-white transition-colors hover:bg-blue-700">
              <Video className="h-4 w-4" /> Entrar na consulta
            </button>
            <p className="mt-4 flex items-center justify-center gap-1.5 text-[11px] text-slate-400"><ShieldCheck className="h-3.5 w-3.5 text-emerald-500" /> Vídeo ao vivo criptografado ponto a ponto (WebRTC)</p>
          </div>
        )}

        {stage === "live" && (
          <div className="w-full">
            <VideoCall roomId={roomId} role="paciente" displayName={name || "Paciente"} peerLabel="o médico" onEnd={() => setStage("ended")} />
          </div>
        )}

        {stage === "ended" && (
          <div className="w-full max-w-md rounded-3xl border border-white/10 bg-white p-8 text-center shadow-2xl">
            <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-50 text-emerald-600"><ShieldCheck className="h-6 w-6" /></div>
            <h1 className="font-heading text-xl font-extrabold text-slate-900">Teleconsulta encerrada</h1>
            <p className="mt-1 text-sm text-slate-500">Obrigado por usar a telemedicina VeloClin.</p>
            <button data-testid="sala-rejoin-btn" onClick={() => setStage("lobby")} className="mt-5 w-full rounded-xl border border-slate-200 py-3 text-sm font-bold text-slate-700 hover:bg-slate-50">Entrar novamente</button>
          </div>
        )}
      </div>
    </div>
  );
}
